export function makeEventsKey(eventId: string, version: number): string {
  return `${eventId}#${version}`;
}
